// Keeps free cushion inners in step when a cover or set quantity changes in
// the cart. Only adjusts inners the customer already has (opt-out respected).
window.TSNFreeInnerSync = window.TSNFreeInnerSync || (() => {
  const innerVariants = { '8526180090029': 45825522401453, '8526179696813': 45825521975469 };
  const covers = {"8529425334445":{"8526180090029":1},"8529426055341":{"8526180090029":1},"8529427234989":{"8526179696813":1},"8529428218029":{"8526179696813":1},"8529429299373":{"8526180090029":1},"8529430937773":{"8526180090029":1},"8529432019117":{"8526180090029":1},"8529433264301":{"8526179696813":1},"8529434542253":{"8526180090029":1},"8529435394221":{"8526180090029":1},"8529436606637":{"8526180090029":1},"8529437229229":{"8526179696813":1},"8603351449773":{"8526180090029":4,"8526179696813":1},"8603356299437":{"8526180090029":4,"8526179696813":1},"8603358265517":{"8526180090029":2,"8526179696813":2},"8603360592045":{"8526180090029":4,"8526179696813":1},"8603362689197":{"8526180090029":4,"8526179696813":1}};
  const root = () => window.Shopify?.routes?.root || '/';
  const required = (cart, innerProductId) => cart.items.reduce((total, item) => {
    const innerChoice = item.properties?.['Cushion inner'];
    if (innerChoice && innerChoice !== 'Free inner added') return total;
    return total + item.quantity * (covers[String(item.product_id)]?.[innerProductId] || 0);
  }, 0);
  const innerLines = (cart, innerProductId) => cart.items.filter((item) => String(item.product_id) === innerProductId);
  const snapshot = async () => {
    const response = await fetch(`${root()}cart.js`, { cache: 'no-store' });
    return response.json();
  };
  const sync = async (before, after, sections) => {
    if (!before?.items || !after?.items) return after;
    const updates = {};
    Object.keys(innerVariants).forEach((innerProductId) => {
      const delta = required(after, innerProductId) - required(before, innerProductId);
      if (delta === 0) return;
      const lines = innerLines(after, innerProductId);
      const current = lines.reduce((total, item) => total + item.quantity, 0);
      if (current === 0) return;
      let target = current + delta;
      if (delta < 0) target = Math.max(Math.min(current, required(after, innerProductId)), target, 0);
      let change = target - current;
      if (change === 0) return;
      if (change > 0) {
        updates[lines[0].key] = lines[0].quantity + change;
        return;
      }
      for (let index = lines.length - 1; index >= 0 && change < 0; index--) {
        const reduce = Math.min(lines[index].quantity, -change);
        updates[lines[index].key] = lines[index].quantity - reduce;
        change += reduce;
      }
    });
    if (Object.keys(updates).length === 0) return after;
    const response = await fetch(`${root()}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections, sections_url: window.location.pathname })
    });
    const updated = await response.json();
    return updated?.items ? updated : after;
  };
  return { snapshot, sync };
})();

if (!window.Eurus.loadedScript.has('product-cart.js')) {
  window.Eurus.loadedScript.add('product-cart.js');

  document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCart', (
        wrappringVariantId,
        engravingVariantId
      ) => ({
        loading: false,
        errorMessage: false,
        mainHasError: false,
        buttonSubmit: "",
        error_message_wrapper: {},
        stopAction: false,
        insuranceVariantId: '',
        loadInsurance(id) {
          if (this.insuranceVariantId == '') {
            this.insuranceVariantId = id;
          }
        },
        scrollToAtcBtn(btnId) {
          const originalAtcBtn = document.querySelector(`#${btnId}`);
          Alpine.store("xHeaderMenu")?.suppressScroll?.();
          originalAtcBtn.scrollIntoView({
            behavior: "smooth",
            block: 'center',
            inline: 'center'
          })
        },
        async addToCart(e, required, quickView, sticky) {
          // Some cards (e.g. "Style it with") get their click handler bound twice;
          // handle each click only once so one press adds one item.
          if (e && e.__tsnAddHandled) return;
          if (e) e.__tsnAddHandled = true;
          this.loading = true;         
          e.preventDefault();

          setTimeout(async () => {
            if (required) {
              var productInfo = this.$el.closest('.product-info');
              if(sticky){
                productInfo = document.querySelector('.product-info');
              }
              if (productInfo) {
                var propertiesInput = productInfo.querySelectorAll(`.customization-picker`);
                this.stopAction = false;
                let scrollStatus = false;
                
                propertiesInput.length && propertiesInput.forEach((input) => {
                  if (input.required && input.value.trim() == '' || input.classList.contains("validate-checkbox")) {
                    input.classList.add("required-picker");
                    this.stopAction = true;
                    if(!scrollStatus){
                      Alpine.store("xHeaderMenu")?.suppressScroll?.();
                      input.parentElement.querySelector('.text-required').scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                      });
                      scrollStatus = true;
                    }    
                  } else {
                    input.classList.remove("required-picker");
                  }                
                });              

                if (!this.stopAction) {
                  productInfo.querySelectorAll('.recipient_input').forEach(giftCardInput => {
                    if (!this.stopAction && giftCardInput.required) {
                      this.stopAction = Alpine.$data(giftCardInput.closest('[x-data]')).onChangeInput(giftCardInput);
                      if (this.stopAction) {
                        Alpine.store("xHeaderMenu")?.suppressScroll?.();
                        giftCardInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
                      }
                    }
                  });
                }
              }
              if (this.stopAction) {
                setTimeout (() => {
                  this.loading = false;
                }, 500);
                return true;
              }
            }
            await Alpine.store('xCartHelper').waitForCartUpdate();
            window.updatingCart = true;

            if (this.$refs.engraving_text && engravingVariantId) {
              if (this.$refs.engraving_text.value.trim()) {
                if (!this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.setAttribute('name', this.$refs.text_area_name.value);
              } else {
                if (this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.removeAttribute('name');
              }
            }

            var productForm = this.$el.closest('.product-info') || this.$el.closest('form');
            if (window.TSNProductAddOns && typeof window.TSNProductAddOns.prepareForm === 'function') {
              window.TSNProductAddOns.prepareForm(this.$refs.product_form);
            }
            let formData = new FormData(this.$refs.product_form);
            const productId = formData.get('product-id');
            let hasTsnProductAddOns = false;
            let isAddAsBundleProduct = false;
            var edt_element = productForm ? productForm.querySelector(`.hidden.cart-edt-properties-${productId}`) : null;
            if (edt_element) {
              edt_element.value = edt_element.value.replace("time_to_cut_off", Alpine.store('xEstimateDelivery').noti)
            }
            formData = new FormData(this.$refs.product_form);
            // Record the customer's free inner choice on the cover line (order evidence).
            const tsnInnerChoiceRoot = this.$refs.product_form?.querySelector('[data-tsn-product-add-ons][data-free-inner-offer="true"]');
            if (tsnInnerChoiceRoot) {
              const innerSelected = window.TSNProductAddOns?.hasSelectedAddOns?.(this.$refs.product_form);
              const innerUnavailable = tsnInnerChoiceRoot.querySelector('[data-tsn-addon-checkbox]')?.disabled;
              formData.set('properties[Cushion inner]', innerSelected ? 'Free inner added' : (innerUnavailable ? 'Inner out of stock' : 'No inner selected'));
            }

            formData.append(
              'sections',
              Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            const newFormData = new FormData();
            for (let [key, value] of formData.entries()) {
              if (value !== '') {
                newFormData.append(key, value);
              }
            }

            const match = document.cookie.match('(^|;)\\s*' + 'eurus_insurance' + '\\s*=\\s*([^;]+)');
            const linkedProductList = newFormData.getAll('properties[_linked_product_id][]');
            const linkedProductListQty = newFormData.getAll('properties[_linked_product_id_qty][]');
            hasTsnProductAddOns = window.TSNProductAddOns && typeof window.TSNProductAddOns.hasSelectedAddOns === 'function' && window.TSNProductAddOns.hasSelectedAddOns(this.$refs.product_form);
            isAddAsBundleProduct = (quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'));
            const isTsnMainBundleProduct = hasTsnProductAddOns
              && typeof window.TSNProductAddOns.mainProductHasComponents === 'function'
              && window.TSNProductAddOns.mainProductHasComponents(this.$refs.product_form);
            let tsnProductAddOnData = [];
            let tsnProductAddOnDataForSeparateAdd = [];
            const appendCartItem = (targetFormData, item, index) => {
              const base = `items[${index}]`;

              targetFormData.append(`${base}[id]`, item.id);
              targetFormData.append(`${base}[quantity]`, item.quantity);

              if (item.selling_plan) {
                targetFormData.append(`${base}[selling_plan]`, item.selling_plan);
              }

                if (item.parent_id) {
                  targetFormData.append(`${base}[parent_id]`, item.parent_id);
                }

              if (item.properties) {
                Object.entries(item.properties).forEach(([key, value]) => {
                  targetFormData.append(`${base}[properties][${key}]`, value);
                })
              }
            };
            const buildCleanFormData = (sourceFormData) => {
              const cleanFormData = new FormData();

              for (let [key, value] of sourceFormData.entries()) {
                if (value !== '') {
                  cleanFormData.append(key, value);
                }
              }

              return cleanFormData;
            };
            if (
              (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) || 
              (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) || 
              (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[1].trim() === '')) || 
              (linkedProductList.length > 0) ||
              (linkedProductListQty.length > 0) ||
              hasTsnProductAddOns
            ) {
              const variantId = formData.get('id');
              const productTitle = productForm ? productForm.querySelector(`.product-variant-title-${formData.get('product-id')}-${variantId}`)?.textContent : null
              let additionalOptionData = [];
              const getMainCartItem = () => {
                const mainItem = {
                  id: variantId,
                  quantity: formData.get('quantity') || 1
                };
                const sellingPlan = formData.get('selling_plan');
                const properties = {};

                if (sellingPlan) {
                  mainItem.selling_plan = sellingPlan;
                }

                for (let [key, value] of formData.entries()) {
                  const propertyName = key.match(/^properties\[(.+)\]$/)?.[1];
                  if (propertyName && value !== '' && !propertyName.startsWith('_linked_product_id')) {
                    properties[propertyName] = value;
                  }
                }

                if (Object.keys(properties).length > 0) {
                  mainItem.properties = properties;
                }

                return mainItem;
              };
              if (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) {
                additionalOptionData.push(
                  {
                    id: wrappringVariantId,
                    quantity: 1,
                    parent_id: variantId,
                    properties: {
                      "For": productTitle
                    }
                  }
                );
              }
              if (linkedProductListQty.length > 0) {
                let qty = newFormData.get('quantity');
                linkedProductListQty.forEach(val => {
                  additionalOptionData.push(
                    {
                      id: val,
                      quantity: qty,
                      parent_id: variantId,
                      properties: {
                        "For": productTitle
                      }
                    }
                  );
                });
              }
              if (linkedProductList.length > 0) {
                linkedProductList.forEach(val => {
                  additionalOptionData.push(
                    {
                      id: val,
                      quantity: 1,
                      parent_id: variantId,
                      properties: {
                        "For": productTitle
                      }
                    }
                  );
                });
              }

              if (hasTsnProductAddOns && typeof window.TSNProductAddOns.getSelectedItems === 'function') {
                const addTsnAddOnsSeparately = isTsnMainBundleProduct;
                const addOnOptions = {
                  parentVariantId: variantId,
                  parentProductId: productId,
                  parentTitle: productTitle,
                  useParentId: !addTsnAddOnsSeparately
                };

                tsnProductAddOnData = window.TSNProductAddOns.getSelectedItems(this.$refs.product_form, addOnOptions);
                if (addTsnAddOnsSeparately) {
                  tsnProductAddOnDataForSeparateAdd = tsnProductAddOnData.map((item) => {
                    const separateItem = { ...item };
                    delete separateItem.parent_id;
                    return separateItem;
                  });
                } else {
                  tsnProductAddOnData.forEach((item) => additionalOptionData.push(item));
                }
              }
              
              if (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) {
                additionalOptionData.push(
                  {
                    id: engravingVariantId,
                    quantity: 1,
                    parent_id: variantId,
                    properties: {
                      "For": productTitle
                    }
                  }
                );
              }
              if (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[1].trim() === '')) {
                additionalOptionData.push(
                  {
                    id: this.insuranceVariantId,
                    quantity: 1
                  }
                );
              }
              if (additionalOptionData.length !== 0) {
                if (hasTsnProductAddOns && isAddAsBundleProduct) {
                  newFormData.delete('id');
                  newFormData.delete('quantity');
                  newFormData.delete('selling_plan');

                  for (let [key] of formData.entries()) {
                    if (key.startsWith('properties[')) {
                      newFormData.delete(key);
                    }
                  }

                  additionalOptionData.unshift(getMainCartItem());
                }

                additionalOptionData.forEach((item, index) => {
                  appendCartItem(newFormData, item, index);
                })
              }
            }

            let resProductId;

            const addToCartRequest = async (body) => {
              const response = await fetch(`${Eurus.cart_add_url}`, {
                method:'POST',
                headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
                body
              });

              const responseText = await response.text();
              try {
                return JSON.parse(responseText);
              } catch (error) {
                return { status: '422', description: Eurus.cart_error_message || 'Something went wrong. Please try again.' };
              }
            };
            // Shopify can add a set and fail (or partly fail) the separate
            // inner request. Compare the cart with the selection and add any
            // inners still missing, so a set never goes through short.
            const tsnFreeInnerRoot = hasTsnProductAddOns
              ? this.$refs.product_form?.querySelector('[data-tsn-product-add-ons][data-free-inner-offer="true"]')
              : null;
            const tsnSelectedInners = tsnFreeInnerRoot
              ? (tsnProductAddOnDataForSeparateAdd.length > 0 ? tsnProductAddOnDataForSeparateAdd : tsnProductAddOnData)
              : [];
            const tsnMainVariantId = String(formData.get('id') || '');
            const tsnMainQuantity = Math.max(1, parseInt(formData.get('quantity') || '1', 10) || 1);
            const getTsnCart = async () => {
              const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' });
              const cart = await cartResponse.json();
              const quantities = new Map();
              cart.items.forEach((item) => {
                const id = String(item.variant_id);
                quantities.set(id, (quantities.get(id) || 0) + item.quantity);
              });
              return { cart, quantities };
            };
            let tsnCartBefore = null;
            if (tsnSelectedInners.length > 0 && tsnMainVariantId) {
              try {
                tsnCartBefore = (await getTsnCart()).quantities;
              } catch (error) {
                tsnCartBefore = null;
              }
            }
            const topUpTsnFreeInners = async () => {
              if (!tsnCartBefore) return null;
              let topUpResponse = null;
              for (let attempt = 0; attempt < 2; attempt++) {
                const { cart, quantities } = await getTsnCart();
                const added = (id) => (quantities.get(String(id)) || 0) - (tsnCartBefore.get(String(id)) || 0);
                const mainAdded = Math.min(tsnMainQuantity, added(tsnMainVariantId));
                if (mainAdded <= 0) return null;
                const missing = tsnSelectedInners.map((item) => {
                  const required = Math.round((Number(item.quantity) / tsnMainQuantity) * mainAdded);
                  return { id: item.id, quantity: required - Math.max(0, added(item.id)) };
                }).filter((item) => item.quantity > 0);
                if (missing.length === 0) {
                  return topUpResponse ? { ...topUpResponse, cart } : (attempt > 0 ? { cart } : null);
                }
                if (attempt > 0) return null;
                const topUpFormData = new FormData();
                topUpFormData.append(
                  'sections',
                  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
                );
                topUpFormData.append('sections_url', window.location.pathname);
                missing.forEach((item, index) => appendCartItem(topUpFormData, item, index));
                topUpResponse = await addToCartRequest(topUpFormData);
              }
              return null;
            };
            const shouldRetryBundleAddOnsSeparately = (response) => {
              return hasTsnProductAddOns
                && tsnProductAddOnDataForSeparateAdd.length > 0
                && response?.status == '422'
                && /bundle products and add-ons cannot be mixed|cannot reference existing parent lines by variant_id/i.test(response.description || '');
            };

            try {
              let response = await addToCartRequest(newFormData);
              let tsnProductAddOnsAddedSeparately = false;

              if (shouldRetryBundleAddOnsSeparately(response)) {
                const mainProductResponse = await addToCartRequest(buildCleanFormData(formData));

                if (mainProductResponse.status == '422') {
                  response = mainProductResponse;
                } else {
                  const addOnsOnlyFormData = new FormData();
                  addOnsOnlyFormData.append(
                    'sections',
                    Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
                  );
                  addOnsOnlyFormData.append('sections_url', window.location.pathname);
                  tsnProductAddOnDataForSeparateAdd.forEach((item, index) => {
                    appendCartItem(addOnsOnlyFormData, item, index);
                  });

                  const addOnsResponse = await addToCartRequest(addOnsOnlyFormData);
                  tsnProductAddOnsAddedSeparately = addOnsResponse.status != '422';
                  response = addOnsResponse.status == '422' ? addOnsResponse : mainProductResponse;
                  if (addOnsResponse.sections) {
                    response.sections = addOnsResponse.sections;
                  }
                }
              }

              if (response.status != '422' && hasTsnProductAddOns && tsnProductAddOnDataForSeparateAdd.length > 0 && !tsnProductAddOnsAddedSeparately) {
                const addOnsOnlyFormData = new FormData();
                addOnsOnlyFormData.append(
                  'sections',
                  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
                );
                addOnsOnlyFormData.append('sections_url', window.location.pathname);
                tsnProductAddOnDataForSeparateAdd.forEach((item, index) => {
                  appendCartItem(addOnsOnlyFormData, item, index);
                });

                const addOnsResponse = await addToCartRequest(addOnsOnlyFormData);
                if (addOnsResponse.status == '422') {
                  response = addOnsResponse;
                } else if (addOnsResponse.sections) {
                  response.sections = addOnsResponse.sections;
                }
              }

              const tsnTopUp = await topUpTsnFreeInners().catch(() => null);
              if (tsnTopUp) {
                if (response.status == '422' && tsnTopUp.sections) {
                  const mainLine = tsnTopUp.cart.items.find((item) => String(item.variant_id) === tsnMainVariantId);
                  response = { ...(mainLine || {}), product_id: mainLine?.product_id || productId };
                }
                if (tsnTopUp.sections) {
                  response.sections = tsnTopUp.sections;
                }
              }

              if (response.status == '422') {
                document.dispatchEvent(new CustomEvent("eurus:product:add-failed", {
                  detail: {
                    errorMessage: response.description
                  }
                }));
                if (typeof response.errors == 'object') {
                  this.error_message_wrapper = response.errors;
                  document.querySelector('.recipient-error-message').classList.remove('hidden');
                } else {
                  this.errorMessage = true;
                  setTimeout(() => {
                    this.errorMessage = false;
                  }, 3000);
                  if(this.$refs.error_message){
                    this.$refs.error_message.textContent = response.description;
                  }
                  if(this.$refs.error_message_mobile){
                    this.$refs.error_message_mobile.textContent = response.description;
                  }
                }
                if (Alpine.store('xMiniCart')) {
                  Alpine.store('xMiniCart').reLoad();
                  document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                }
              } else {
                resProductId = response.product_id;

                if (this.$refs.product_form) {
                  document.dispatchEvent(new CustomEvent(`eurus:cart:custom-options:reset:${this.$refs.product_form.getAttribute('id')}`));
                }

                if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
                  Alpine.store('xCartNoti').setItem(response); 
                }
                document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
                this.error_message_wrapper = {};
      
                if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                  Alpine.store('xQuickView').show = false;
                }
                Alpine.store('xPopup').close();
                document.dispatchEvent(new CustomEvent("eurus:video-popup:close-popup"));
                if(!hasTsnProductAddOns && isAddAsBundleProduct) {
                  document.dispatchEvent(new CustomEvent("eurus:cart:add-as-bundle"));
                } else {
                  Alpine.store('xCartHelper').reRenderSections(response.sections);
                  if (!Alpine.store('xCartNoti') || !Alpine.store('xCartNoti').enable) {
                    Alpine.store('xMiniCart').openCart();
                  }               
                  Alpine.store('xCartHelper').currentItemCount = parseInt(document.getElementById('cart-icon-bubble').innerHTML);
                  if (Alpine.store('xQuickView')) {
                    Alpine.store('xQuickView').openPopupMobile = false;
                  }
                  this.$el.closest('.choose-options')?.getElementsByClassName('js-close-button')[0].click();
                  this.$el.closest('.js-product-container')?.getElementsByClassName('js-close-button')[0].click();
                  document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                  document.dispatchEvent(new CustomEvent("eurus:cart:redirect"));
                  document.dispatchEvent(new CustomEvent("eurus:product:added", {
                    detail: {
                      product: response
                    }
                  }));
                }
              }
            } catch (error) {
              document.dispatchEvent(new CustomEvent("eurus:product:add-failed", {
                detail: {
                  errorMessage: error
                }
              }));
              console.error('Error:', error);
            } finally {
              window.updatingCart = false;
              document.dispatchEvent(new CustomEvent(`eurus:product-card:clear:${resProductId}`));
              this.loading = false;
              if (!isAddAsBundleProduct || hasTsnProductAddOns) {
                if(this.$refs.gift_wrapping_checkbox) this.$refs.gift_wrapping_checkbox.checked = false;
              }
              document.cookie = `eurus_insurance=${this.insuranceVariantId}; path=/`;  
            }
          }, 0)
        }
      }))
    });
}
